<template>
  <div class="head-page">
    <Header :title="$t('bank.title')" :isreturn="true" />
    <div class="head-tab-page-overflow">
      <div class="bank-box" v-for="(item, index) in dataLst" :key="index">
        <ul @click="toShow(item)">
          <li>
            <div class="title">{{ $t("bank.bankName") }} :</div>
            <div class="value">{{ item.bank_name }}</div>
          </li>
          <li>
            <div class="title">{{ $t("bank.cardCode") }} :</div>
            <div class="value" v-if="safeWapConfig.bank_swan_type == 1">********{{ item.card_number.slice(-4) }}</div>
            <div class="value" v-else>{{ item.card_number }}</div>
          </li>
          <li style="border: none">
            <div class="title">{{ $t("bank.usrName") }} :</div>
            <div class="value">{{ item.card_name }}</div>
          </li>
        </ul>
        <div class="to-bank">
          <van-icon name="arrow" size="18" />
        </div>
      </div>
    </div>
    <BankFooter @toShow="toShow" v-if="btnShow" />
    <van-popup v-model="show" round position="bottom" :closeable="true">
      <BankInfo @reset-data="ResetData" :dataItem="dataItem" :btnshow="btnShow" />
    </van-popup>
  </div>
</template>

<script>
import Header from "@/components/Header/index.vue";
import { BankInfo, BankFooter } from "./components/index";
export default {
  name: "UsrBank",
  inject: ["app"],
  computed: {
    safeWapConfig() {
      return this.app.wapConfig || {};
    },
  },
  components: { Header, BankInfo, BankFooter },
  data() {
    return {
      show: false,
      dataLst: [],
      dataItem: {},
      btnShow: false
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    toShow(val) {
      this.show = true;
      const that = this;
      this.$nextTick(() => {
        that.dataItem = val;
      });
    },
    ResetData() {
      this.show = false;
      this.getData();
    },
    async getData() {
      await this.$http({
        method: "post",
        url: "getUserBankList",
      }).then((res) => {
        if (res && res.data && res.data) {
          this.dataLst = res.data;
          if(this.dataLst.length > 0){
            this.btnShow = this.safeWapConfig.can_edit_bank == 1
          } else {
            this.btnShow = true
          }
        }
      });
    },
  },
};
</script>

<style>
</style>
